import styled from 'styled-components'

export const Container = styled.div`
  padding: 8px 8px 8px 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const AddressBox = styled.p`
  width: 90%;
  background-color: yellow;
  font-weight: bold;
  font-size: 18px;
  border: 1px;
  border-style: solid;
  border-radius: 3px;
  border-color: ${({ color }) => color};
  display: flex;
  justify-content: center;
  padding: 8px 8px 8px 8px;
  color: ${({ color }) => color};
`

export const Info = styled.p`
  font-weight: bold;
  font-size: 18px;
  display: flex;
  justify-content: center;
  padding: 8px 8px 0px 8px;
  color: ${({ color }) => color};
`

export const ProductInfoBox = styled.p`
  margin-top: 8px !important;
  width: 90%;
  background-color: #839BCB;
  font-weight: bold;
  font-size: 14px;
  border: 1px;
  border-style: solid;
  border-color: ${({ color }) => color};
  border-radius: 3px;
  display: flex;
  justify-content: center;
  padding: 8px 8px 8px 8px;
  color: ${({ color }) => color};
`

export const BatchQuantity = styled.p<{color: string}>`
  font-weight: bold;
  font-size: 14px;
  margin-top: 10px !important;
  margin-bottom: 10px !important;
  padding: 8px 18px 8px 18px;
  width: fit-content;
  border: 1px;
  border-style: solid;
  border-color: ${({ color }) => color};
  border-radius: 3px;
  display: flex;
  justify-content: center;
  color: ${({ color }) => color};
`

export const ConfirmModalContainer = styled.span`
  display: grid;
`

export const ConfirmModalText = styled.label`
  font-size: 15px;
`

export const ConfirmModalConfirmationText = styled.label`
  font-size: 15px;
  font-weight: bold;
  text-align: end;
  margin-top: 10px !important;
`
